import type { MaybeRefOrGetter } from 'vue';
import { isRef, toValue } from 'vue';

export function abortApiCall(abortControllerRef: MaybeRefOrGetter<AbortController | null> | null) {
  toValue(abortControllerRef)?.abort();
}

export function refreshAbortController(abortControllerRef: unknown) {
  if (!abortControllerRef || !isRef<AbortController | null>(abortControllerRef)) {
    throw new Error('ref required for refreshAbortController');
  }

  // Cancel last request if present
  abortApiCall(abortControllerRef);

  const newController = new AbortController();
  abortControllerRef.value = newController;
  return newController.signal;
}

export function isCancelError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') return true;
  return (
    error != null &&
    typeof error === 'object' &&
    'name' in error &&
    (error as Error).name === 'CanceledError'
  );
}

export function handleCancelError(error: Error, callback?: () => void) {
  if (!isCancelError(error)) {
    throw error;
  }
  callback?.();
}
